import request from './request';
import requestWithoutTimeout from './requestWithoutTimeout';

const cartsService = {
  getAll: (params) => request.get('dashboard/admin/carts', { params }),
  export: (params) =>
    requestWithoutTimeout.get('dashboard/admin/carts/export', { params }),
};

export default cartsService;

